import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Card, Divider, Typography } from "@mui/material";
import {
  AccessTime,
  AccessTimeFilled,
  ArrowBack,
  ChevronRight,
  Person,
} from "@mui/icons-material";
import Error from "../Error";
import Solo from "../../assets/images/Solo.svg";
import Group from "../../assets/images/Group.svg";
import SimplePopper from "./SimplePopper";
const options = [
  {
    name: "One-on-one",
    people: "One host with one invitee",
    href: "/app/create/one?back=1",
    img: Solo,
  },
  {
    name: "Group",
    people: "One host with a group of invitees",
    href: "/app/create/group?back=1",
    img: Group,
  },
];
const EventChoice = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  console.log(props);
  const navigate = useNavigate();
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        marginTop: "20px",
      }}
    >
      <Card
        className="event-card noWidth"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          borderRadius: "10px",
          maxWidth: "600px",
          justifyContent: "space-between",
          height: "300px",
          boxShadow: "none",
          margin: "0px 20px",
          border: "1px solid var(--color-grey-3,#CCCCCC)",
        }}
      >
        <SimplePopper
          anchorEl={anchorEl}
          handleAwayClick={() => {
            setAnchorEl(null);
          }}
        />
        {options.map((val, ind) => (
          <>
            <div
              style={{
                flex: 1,
                height: "100%",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                borderRadius: ind ? " 0 0 10px 10px" : " 10px 10px 0 0",
              }}
              onClick={(e) => {
                props.decodedToken.role.toLowerCase() == "starter"&&val.name=="Group"
                  ? handleClick(e)
                  : navigate(val.href);
              }}
              className="card"
            >
              <img
                style={{
                  height: "80px",
                  width: "30%",
                  flex: 1.5,
                  margin: "0 10px",
                }}
                src={val.img}
              />
              <div
                style={{
                  flex: 2,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: "3px",
                }}
              >
                <Typography variant="h5" className="font">
                  {val.name}
                </Typography>
                <h2 className="font" style={{ fontSize: "15px" }}>
                  {val.people}
                </h2>
              </div>
              <div className="flex align justify">
                <ChevronRight />
              </div>
            </div>
            <Divider />
          </>
        ))}
      </Card>
    </div>
  );
};

export default EventChoice;
